import { docsConstants } from 'src/_constants';
import { docsService } from 'src/_services';
import { alertActions } from '.';

export const docActions = {
    getAll,
    add,
    getById,
    update,
    updateField,
    _delete,
    uploadDocs,

    getAllCat,
    addCat,
    getCatById,
    updateCat,
    updateFieldCat,
    _deleteCat,
};


function getAll() {
    return dispatch => {
        dispatch(request());
        return docsService.getAll()
            .then(
                docs => {
                    dispatch(success(docs));
                    return docs;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request() { return { type: docsConstants.GETALL_REQUEST } }
    function success(docs) { return { type: docsConstants.GETALL_SUCCESS, docs } }
    function failure(error) { return { type: docsConstants.GETALL_FAILURE, error } }
}

function getById(id) {

    return dispatch => {
        dispatch(request());
        docsService.getById(id)
            .then(
                doc => dispatch(success(doc)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request() { return { type: docsConstants.GET_REQUEST } }
    function success(doc) { return { type: docsConstants.GET_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.GET_FAILURE, error } }
}

function add(doc) {
    return dispatch => {
        dispatch(request(doc));

        return docsService.add(doc)
            .then(
                doc => {
                    dispatch(success(doc));
                    dispatch(alertActions.success('Thêm mới Văn Bản thành công!'));
                    return doc;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(doc) { return { type: docsConstants.ADD_REQUEST, doc } }
    function success(doc) { return { type: docsConstants.ADD_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.ADD_FAILURE, error } }
}

function update(doc) {
    return dispatch => {
        dispatch(request(doc));
        docsService.update(doc)
            .then(
                doc => {
                    dispatch(success(doc));
                    dispatch(alertActions.success('Cập nhật thông tin Văn Bản thành công!'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(doc) { return { type: docsConstants.UPDATE_REQUEST, doc } }
    function success(doc) { return { type: docsConstants.UPDATE_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.UPDATE_FAILURE, error } }
}

function updateField(doc, field) {
    return dispatch => {
        dispatch(request(doc, field));
        docsService.updateField(doc, field)
            .then(
                doc => {
                    dispatch(success(doc));
                    dispatch(alertActions.success('Cập nhật thông tin Văn Thư thành công!'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(doc, field) { return { type: docsConstants.UPDATE_FIELD_REQUEST, doc, field } }
    function success(doc) { return { type: docsConstants.UPDATE_FIELD_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.UPDATE_FIELD_FAILURE, error } }
}

function _delete(doc) {
    return dispatch => {
        dispatch(request(doc));
        return docsService._delete(doc)
            .then(
                doc => {
                    dispatch(success(doc));
                    dispatch(alertActions.success('Xoá Văn Bản thành công!'));
                    return doc;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function request(doc) { return { type: docsConstants.DELETE_REQUEST, doc } }
    function success(doc) { return { type: docsConstants.DELETE_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.DELETE_FAILURE, error } }
}

function uploadDocs(doc, upload_files, object, object_id, user) {
    return dispatch => {
        dispatch(request(doc));
        return docsService.uploadDocs(doc, upload_files, object, object_id, user)
            .then(
                doc => {
                    dispatch(success(doc));
                    return doc;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function request(doc) { return { type: docsConstants.UPLOAD_REQUEST, doc } }
    function success(doc) { return { type: docsConstants.UPLOAD_SUCCESS, doc } }
    function failure(error) { return { type: docsConstants.UPLOAD_FAILURE, error } }
}

// CATEGORIES
function getAllCat() {
    return dispatch => {
        dispatch(request());
        return docsService.getAllCat()
            .then(
                categories => {
                    dispatch(success(categories));
                    return categories;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request() { return { type: docsConstants.CAT_GETALL_REQUEST } }
    function success(categories) { return { type: docsConstants.CAT_GETALL_SUCCESS, categories } }
    function failure(error) { return { type: docsConstants.CAT_GETALL_FAILURE, error } }
}

function getCatById(id) {
    return dispatch => {
        dispatch(request());
        docsService.getCatById(id)
            .then(
                category => dispatch(success(category)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function request() { return { type: docsConstants.CAT_GET_REQUEST } }
    function success(category) { return { type: docsConstants.CAT_GET_SUCCESS, category } }
    function failure(error) { return { type: docsConstants.CAT_GET_FAILURE, error } }
}

function addCat(category) {
    return dispatch => {
        dispatch(request(category));

        return docsService.addCat(category)
            .then(
                category => {
                    dispatch(success(category));
                    dispatch(alertActions.success('Thêm mới Nhóm Văn Bản thành công!'));
                    return category;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(category) { return { type: docsConstants.CAT_ADD_REQUEST, category } }
    function success(category) { return { type: docsConstants.CAT_ADD_SUCCESS, category } }
    function failure(error) { return { type: docsConstants.CAT_ADD_FAILURE, error } }
}

function updateCat(category) {
    return dispatch => {
        dispatch(request(category));
        docsService.updateCat(category)
            .then(
                category => {
                    dispatch(success(category));
                    dispatch(alertActions.success('Cập nhật thông tin Nhóm Văn Bản thành công!'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(category) { return { type: docsConstants.CAT_UPDATE_REQUEST, category } }
    function success(category) { return { type: docsConstants.CAT_UPDATE_SUCCESS, category } }
    function failure(error) { return { type: docsConstants.CAT_UPDATE_FAILURE, error } }
}

function updateFieldCat(category, field) {
    return dispatch => {
        dispatch(request(category, field));
        docsService.updateFieldCat(category, field)
            .then(
                doc => {
                    dispatch(success(category));
                    dispatch(alertActions.success('Cập nhật thông tin Nhóm Văn Bản thành công!'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(category, field) { return { type: docsConstants.CAT_UPDATE_FIELD_REQUEST, category, field } }
    function success(category) { return { type: docsConstants.CAT_UPDATE_FIELD_SUCCESS, category } }
    function failure(error) { return { type: docsConstants.CAT_UPDATE_FIELD_FAILURE, error } }
}

function _deleteCat(category) {
    return dispatch => {
        dispatch(request(category));
        return docsService._deleteCat(category)
            .then(
                doc => {
                    dispatch(success(doc));
                    dispatch(alertActions.success('Xoá Nhóm Văn Bản thành công!'));
                    return doc;
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(category) { return { type: docsConstants.CAT_DELETE_REQUEST, category } }
    function success(category) { return { type: docsConstants.CAT_DELETE_SUCCESS, category } }
    function failure(error) { return { type: docsConstants.CAT_DELETE_FAILURE, error } }
}

